// Autogenerated by `pnpm version-file`. DO NOT EDIT
export var VERSION = '1.47.1';
//# sourceMappingURL=version.js.map